import { createStyles, makeStyles } from '@material-ui/core'

export default makeStyles((theme) =>
  createStyles({
    text: { textTransform: 'none', fontSize: 16 },
    root: {
      textTransform: 'none',
      borderRadius: theme.shape.buttonRadius,
      '&.MuiButton-containedSecondary.Mui-disabled': {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.common.white,
        opacity: 0.6,
      },
    },
  })
)
